// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2BUFg","content":"Consent_content__12EDU","footer":"Consent_footer__1cCbs"};